// extracted by mini-css-extract-plugin
export default {"aiUploadingTextColor":"EVVfBDaPljteXjVajt0g","text":"THRQQWihHqcHzJKqZoOD"};